import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.VUE_APP_AES_SECRET_KEY;

const secretPadded = SECRET_KEY.padEnd(32, '0');
const secureKey = CryptoJS.enc.Utf8.parse(secretPadded.substring(0, 32));
const ivParameter = CryptoJS.enc.Utf8.parse(secretPadded.substring(0, 16));

const securityConfig = {
    iv: ivParameter,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
};

export const encryptData = (input) => {
    if (input === null || input === undefined) return input;

    const inputData = CryptoJS.enc.Utf8.parse(
        typeof input === 'string' ? input : JSON.stringify(input)
    );

    const encrypted = CryptoJS.AES.encrypt(inputData, secureKey, securityConfig);

    return '**:' + toUrlSafeBase64(CryptoJS.enc.Base64.stringify(encrypted.ciphertext));
};

const toUrlSafeBase64 = (base64String) => {
    return base64String
        .replace(/\+/g, '-') // replace + with -
        .replace(/\//g, '_') // replace / with _
        .replace(/==/g, '~~'); // replace == with ~~
};

// new: Generic function to encrypt and replace placeholders in URL
export function encryptUrlPlaceholders(url, encryptParams = {}) {
    let processedUrl = url;

    // regex to match {encrypt:variableName}
    const encryptRegex = /\{encrypt:([^}]+)\}/g;

    let match;
    while ((match = encryptRegex.exec(url)) !== null) {
        const variableName = match[1];
        if (encryptParams[variableName]) {
            const encryptedValue = encryptData(encryptParams[variableName]);
            processedUrl = processedUrl.replace(match[0], encryptedValue);
        } else {
            // if no value provided, leave as-is or throw error
            console.warn(`No value provided for {encrypt:${variableName}}`);
        }
    }

    return processedUrl;
}